import { useNavigate } from 'react-router-dom';
import logo from '@/assets/Logo.png';
import { routes } from '@/constants/routes';
import BottomNavbar from '@/components/BottomNavbar';

const LargeContainer = ({ children, withImage = true }) => {
	const navigate = useNavigate();

	return (
		<>
			<div className={`h-full w-screen flex ${window.innerHeight > 568 ? 'items-center' : 'items-start pt-8'} justify-center md:items-center`}>
				<div className="flex flex-col items-center bg-white/90 rounded-3xl shadow-2xl p-4 w-4/5 text-center md:px-6 md:py-8 md:w-3/4">
					{withImage && (
						<img
							onClick={() => navigate(routes.home)}
							src={logo}
							alt="logo"
							className="hover:cursor-pointer mb-4 w-1/2 md:w-2/5 lg:w-1/5"
						/>
					)}

					{children}
				</div>
			</div>

			<BottomNavbar />
		</>
	);
};

export default LargeContainer;
